import { createContext } from 'react';

import type { RectanglePoint } from '../components/overlay/explore/types.js';
import type { XYChartSelectionRectangleMetadata } from '../hooks/useSortRectangleDatapoints.js';
import type { AxisIdToScaleDomain } from '../types/xy-chart-internals.js';
import { AxisIdToScales } from './XYChartScales.context.js';

export interface XYChartRectSelectionContextValue {
  hasDatapoints: boolean;
  searchAllAxisDatapoints: (
    start: number,
    end: number,
    callback: (point: XYChartSelectionRectangleMetadata) => RectanglePoint,
    axesIds: string | string[],
    axisIdToScales: AxisIdToScales,
    axisIdToScaleDomain: AxisIdToScaleDomain,
    axisIdToIsRelative: Map<string, boolean>,
  ) => {
    axesCurrentSelection: Record<string, RectanglePoint[]>;
    highlightedDatapoints: RectanglePoint[];
  };
}

export const XYChartRectSelectionContext = createContext<
  XYChartRectSelectionContextValue | undefined
>(undefined);
